'use strict';

// Assigned Dependencies
require('jquery-validate');
require('jquery-validate-additional-methods');

module.exports = (function() {
	window.setupForms = function(){
		setupValidatorAdditionalMethods();
		setupAdaptiveForms();
		setupFormValidation();
		setupSpecialRadios();
		setupStyledInputs();
		TriggerAutoSubmitForm();
		detectInputFocus();
		setupSpecialRadios();
    $(".accordion").foundation().on(
      "down.zf.accordion",
      function(event, item) {
        var activatorHeight = $("a.accordion-title", $(item).parent()).outerHeight();
        $('html,body').animate({scrollTop: $(item).offset().top - activatorHeight}, 'slow');
      }
    );

		setTimeout(() => {
			if (window.LCBForm && typeof window.LCBForm.init === 'function') {
				window.LCBForm.init()
			}
		}, 100)
	}
	setupForms();

	window.setupSpecialRadios = function() {
		setupSpecialRadios();
	}

	window.addDynamicElementsToForm = function(elements) {
		addDynamicElementsToForm(elements);
	};

})();

function detectInputFocus() {
	$('input').focus(function() {
		$('.sticky-side-bar').addClass('remove-fix');
	});
	$('input').blur(function() {
		$('.sticky-side-bar').removeClass('remove-fix');
	});
}

function setupStyledInputs() {
	$('.styled-input').click(function() {

		var input =  $(this).find('input');

		if (input.attr('type') == 'checkbox') {
			var styledDiv = $(this).children('div .radio-icon');
			if ($(input).is(':checked')) {
				styledDiv.addClass('active');
			}
			else {
				styledDiv.removeClass('active');
			}
		}
		else {
			var name = $(this).find('input').attr('name');
			$('[name="' + name + '"]').siblings('.radio-icon').removeClass('active');
			if ($(input).is(':checked')) {
				$(input).siblings('.radio-icon').addClass('active');
			}
		}
	});
}

function addDynamicElementsToForm(elements) {
	$(elements).each(function() {
		$(this).rules('add', getElementValidationRules($(this)));
	});
}

function setupSpecialRadios() {
	$('.special-radios').each(function() {
		var parent = $(this);
		$(parent).find('.radio input[type="radio"]').on('click', function() {
			$(parent).find('.radio').removeClass('selected');
			$(this).closest('.radio').addClass('selected');
		});

		$(parent).find('[type="radio"]').each(function() {
			$(this).focus(function() {
				$(this).siblings('label').addClass('focus');
			});
		});

		$(parent).find('[type="radio"]').each(function() {
			$(this).blur(function() {
				$(this).siblings('label').removeClass('focus');
			});
		});
	});
}

function updateLabelFocus(input, label) {
    if (input.val().length > 0 || input.is(":focus") || input.attr("placeholder")) {
        label.addClass('focus');
    } else {
        label.removeClass('focus');
    }
}

function setupAdaptiveForms() {
    $('.form-row').each(function () {
        var input = $(this).find('.adaptive-field');
        var label = $(this).find('.adaptive-label');

        if (input.hasClass("constant-focus")) {
            label.addClass('focus');
        } else if (input.length > 0) {
            label.click(function () {
                input.focus();
            });

            input.on({
                input: function () {
                    updateLabelFocus(input, label);
                },
                focus: function () {
                    updateLabelFocus(input, label);
                },
                blur: function () {
                    updateLabelFocus(input, label);
                }
            });

            updateLabelFocus(input, label);
        }
    });
}

function checkAccordionForm(form) {
	setTimeout(function() {
		$(form).find('.accordion-item').each(function() {
			var element = $(this);
			var anyError = $(element).find('div.error').length > 0;
			var anyValid = $(element).find('.valid').length > 0;
	    	if (anyError) {
	    		$(element).removeClass('no-errors').addClass('has-error');
	    	}
	    	else if(anyValid) {
	    		$(element).removeClass('has-error').addClass('no-errors');
	    	}
		});
	}, 80);
}


function TriggerAutoSubmitForm() {
	var $autoSubmitForms = $('form[data-auto-submit]');
	if ($autoSubmitForms.length > 0) {
		$autoSubmitForms.submit();
	}
}

function setupFormValidation() {
	var forms = $('form[data-js-validate="true"]');
	$(forms).each(function() {
		var form = $(this);
		var validationRules = getFormValidationRules(form);
		var validationMessages = getFormValidationMessages(form);
		validateForm(form, validationRules, validationMessages);
	});
}

function validateForm(form, validationRules, validationMessages) {
	$(form).validate({
		ignore: [],
		invalidHandler: function(event, validator) {
			checkAccordionForm(form);
		},
		highlight: function(element, errorClass, validClass) {
            $(element).addClass('error').removeClass('valid');
            $(element).parent().find('.adaptive-label').addClass('error-lbl').removeClass('valid-lbl');
            checkAccordionForm(form);
        },
        unhighlight: function(element, errorClass, validClass) {
        	var errorEl = $(element).attr('data-error-element');
        	if (typeof errorEl !== typeof undefined && errorEl !== false) {
				$(errorEl).find('div.error').remove();
			}
			else {
				$(element).parents('.form-row').find('div.error').remove();
			}
            $(element).addClass('valid').removeClass('error');
            $(element).parent().find('.adaptive-label').addClass('valid-lbl').removeClass('error-lbl');
						$(element).parents('.lcb-form__field').addClass('field-focused');
            checkAccordionForm(form);
        },
		errorElement: "div",
		errorPlacement: function(error, element) {
			var errorEl = $(element).attr('data-error-element');
        	if (typeof errorEl !== typeof undefined && errorEl !== false) {
				$(errorEl).empty().append(error);
			}
         	else if ($(element).attr('type') == "radio" || $(element).attr('type') == "checkbox") {
        		$(element).parents('.form-row').remove('div.error');
        		if ($(element).parents('.form-row').find('div.error').length == 0) {
        			$(element).parents('.form-row').append(error);
        		}
        	}
        	else {
        		error.insertAfter(element);
        	}
        },
		rules : validationRules,
		messages : validationMessages
	});
}

function getFormValidationRules(form) {
	var validationRules = {};
	$(form).find('[data-validation-rules]').each(function() {
		var input = $(this);
		var rules = $(this).attr('data-validation-rules').split(',');
		var processedRules = processFormDataValidationRules(rules);
		validationRules[input.attr('name')] = processedRules;
	});
	return validationRules;
}


function getElementValidationRules(element) {
	var rules = $(element).attr('data-validation-rules').split(',');
	var processedRules = processFormDataValidationRules(rules);
	return processedRules;
}

function getFormValidationMessages(form) {
	var validationMessages = {};
	$(form).find('[data-validation-message]').each(function() {
		var input = $(this);
		var messages = $(this).attr('data-validation-message').split(',');
		var processedMessages = processFormDataValidationMessages(messages);
		validationMessages[input.attr('name')] = processedMessages;
	});
	return validationMessages;
}

function processFormDataValidationRules(rules) {
	var result ={};
	for (var i=0;i<rules.length;i++) {
		var rule = rules[i];
		var ruleVal = '';
		if (rule.indexOf(':') > -1) {
			var ruleArr = rule.split(':');
			rule = ruleArr[0];
			ruleVal = ruleArr.length > 1 ? ruleArr[1] : '';
		}
		switch(rule) {
			case 'required':
			case 'email':
			case 'integer':
				result[rule] = true;
				break;
			case 'min':
			case 'max':
				result[rule] = parseFloat(ruleVal);
				break;
			case 'creditcard':
				result['creditCard'] = true;
				break;
			case 'minLength':
				result['minlength'] = parseInt(ruleVal);
				break;
			case 'maxLength':
				result['maxlength'] = parseInt(ruleVal);
				break;
			case 'equalTo':
				var el = ruleVal.indexOf('.') == 0 || ruleVal.indexOf('#') == 0 ? ruleVal : '[name="'+ruleVal+'"]';
				result[rule] = el;
				break;
			case 'currency':
				result[rule] = ["$,£,¢",false];
				break;
			case 'requireFromGroup':
				var el = ruleVal.split('#');
				if (el.length == 2) {
					result['require_from_group'] = [el[0],el[1]];
				}
			break;
			case 'range':
				var el = ruleVal.split('-');
				if (el.length == 2) {
					result[rule] = [el[0],el[1]];
				}
				break;
			case 'extension':
			default:
				result[rule] = ruleVal;
				break;
		}
	}

	return result;
}

function processFormDataValidationMessages(messages) {
	var result ={};
	for (var i=0;i<messages.length;i++) {
		var message = messages[i];
		var messageVal = '';
		if (message.indexOf(':') > -1) {
			var messageArr = message.split(':');
			message = messageArr[0];
			messageVal = messageArr.length > 1 ? messageArr[1] : '';
			switch(message) {
				case 'creditcard':
					result['creditCard'] = messageVal;
					break;
				case 'minLength':
					result['minlength'] = messageVal;
					break;
				case 'maxLength':
					result['maxlength'] = messageVal;
					break;
				case 'requireFromGroup':
					result['require_from_group'] = messageVal;
					break;
				default:
					result[message] = messageVal;
					break;
			}
		}
		else {
			result['required'] = message;
		}
	}

	return result;
}

function setupValidatorAdditionalMethods() {

    jQuery.validator.addMethod("creditCard", function(value, element) {
		if (/[^0-9\-]+/.test(value)) {
			return false;
		}

		value = value.replace(/\D/g, "");

		var validTypes = 0x0001 | 0x0002 | 0x0004;

		if (validTypes & 0x0001 && /^(5[12345])/.test(value)) { //mastercard
			return value.length == 16;
		}
		if (validTypes & 0x0002 && /^(4)/.test(value)) { //visa
			return value.length == 16;
		}
		if (validTypes & 0x0004 && /^(3[47])/.test(value)) { //amex
			return value.length == 15;
		}
		if (validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test(value)) { //dinersclub
			return value.length == 14;
		}
		if (validTypes & 0x0010 && /^(2(014|149))/.test(value)) { //enroute
			return value.length == 15;
		}
		if (validTypes & 0x0020 && /^(6011)/.test(value)) { //discover
			return value.length == 16;
		}
		if (validTypes & 0x0040 && /^(3)/.test(value)) { //jcb
			return value.length == 16;
		}
		if (validTypes & 0x0040 && /^(2131|1800)/.test(value)) { //jcb
			return value.length == 15;
		}
		if (validTypes & 0x0080) { //unknown
			return true;
		}
		return false;
	}, "Please enter a valid credit card number");
}